<ng-container *ngIf="displayBanner.length">
  <div class="" style="border-radius: 8px; overflow: hidden">
    <div class="w-full d-flex justify-content-center d-none d-md-flex">
      @for (banner of displayBanner; track $index) {
      @if (!!banner.direction) {
      <div style="width: 50%" (click)="goToUrl(banner)" [style.cursor]="banner.direction ? 'pointer' : 'auto'">
        <img style="width: 100%; height: auto;" [appCachedImage]="banner.imgUrlPC" [fallbackImage]="'assets/images/image-placeholder.svg'" alt="banner" loading="lazy" />
      </div>
      } @else {
      <img style="width: 50%;" [appCachedImage]="banner.imgUrlPC" [fallbackImage]="'assets/images/image-placeholder.svg'" alt="banner" loading="lazy" />
      }
      }
    </div>
    <div class="w-full d-flex justify-content-center d-md-none">
      @for (banner of displayBanner; track $index) {
      @if (!!banner.direction) {
      <div class="d-flex align-items-center justify-content-between text-white"
        style="height: 42px; width: 50%; padding: 6px; cursor: pointer" [style.background]="banner.background"
        (click)="goToUrl(banner)">
        <div class="d-flex align-items-center" style="gap: 12px">
          @if (banner.imgIcon) {
          <img [appCachedImage]="banner.imgIcon" [fallbackImage]="'assets/images/image-placeholder.svg'" width="34px" height="34px" alt="icon"  loading="lazy" />
          }
          @if (banner.imgTextInside) {
          <img [appCachedImage]="banner.imgTextInside" [fallbackImage]="'assets/images/image-placeholder.svg'" height="34px" style="max-width: calc(100%);" alt="text-inside" loading="lazy" />
          }
        </div>
        <div class="d-flex align-items-center justify-content-center">
          <img src="assets/svg/product/pointer.svg" class="icon-animate" alt="pointer" loading="lazy" />
        </div>
      </div>
      } @else {
      <div class="d-flex align-items-center justify-content-between text-white"
        style="height: 42px; width: 50%; padding: 6px" [style.background]="banner.background">
        <div class="d-flex align-items-center" style="gap: 12px">
          @if (banner.imgIcon) {
          <img [appCachedImage]="banner.imgIcon" [fallbackImage]="'assets/images/image-placeholder.svg'" width="34px" height="34px" alt="icon" loading="lazy" />
          }
          @if (banner.imgTextInside) {
          <img [appCachedImage]="banner.imgTextInside" [fallbackImage]="'assets/images/image-placeholder.svg'" height="34px" style="max-width: calc(100%);" alt="text-inside" loading="lazy" />
          }
        </div>
        <div class="d-flex align-items-center justify-content-center">
          <img src="assets/svg/product/pointer.svg" class="icon-animate" alt="pointer" loading="lazy" />
        </div>
      </div>
      }
      }
    </div>
  </div>
</ng-container>
